import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row, Typography, Layout, Spin, Space } from "antd";
import { UserOutlined, TeamOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import lingkarancekapLogoImg from "../assets/lingkarancekap_logo.png";

const { Title, Text } = Typography;
const { Content } = Layout;

const apiParkingBase = process.env.BUN_PUBLIC_PARKING_API_BASE;

export function Home() { 
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const parkingLocationId = searchParams.get('id') || '';
  const [configLoading, setConfigLoading] = useState(true);
  const [enableRegistration, setEnableRegistration] = useState(false);
  const [locationName, setLocationName] = useState('');

  useEffect(() => {
    const fetchConfig = async () => {
      if (!parkingLocationId) {
        setConfigLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${apiParkingBase}/api/public/parking-locations/settings`, {
          params: { id: parkingLocationId }
        });
        setEnableRegistration(response.data.enable_registration || false);
        setLocationName(response.data.location || 'License Plate Recognition (LPR) Lanes Registration');
      } catch (error) {
        console.error("Failed to fetch config:", error);
        setEnableRegistration(false);
      } finally {
        setConfigLoading(false);
      }
    };
    fetchConfig();
  }, [parkingLocationId]);

  if (configLoading) {
    return (
      <Layout style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
        <Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
          <Card style={{ textAlign: 'center', padding: '40px' }}>
            <Spin size="large" />
            <div style={{ marginTop: 16, fontSize: '16px' }}>Loading...</div>
          </Card>
        </Content>
      </Layout>
    );
  }

  if (!enableRegistration) {
    return (
      <Layout style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
        <Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '24px' }}>
          <Card style={{ textAlign: 'center', padding: '40px', maxWidth: '600px' }}>
            <Title level={2} style={{ color: '#1890ff', marginBottom: 24 }}>
              {locationName}
            </Title>
            <div style={{ padding: '24px', background: '#fff7e6', borderRadius: '8px', border: '1px solid #ffd591' }}>
              <Text style={{ color: '#d46b08', fontSize: '18px' }}>
                Registration is currently disabled for this location.
              </Text>
            </div>
          </Card>
        </Content>
      </Layout>
    );
  }

  return (
    <Layout
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}
    >
      <Content
        style={{
          padding: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'auto',
          minHeight: '100vh',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '900px',
            margin: '0 auto',
          }}
        >
          <Card
            style={{
              width: '100%',
              background: 'white',
              borderRadius: '16px',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.15)',
              padding: '40px 32px',
            }}
          >
            {/* Logo Section */}
            <div style={{ textAlign: 'center', marginBottom: 24 }}>
              <img 
                src={lingkarancekapLogoImg}
                alt="Logo"
                style={{
                  height: '100px',
                  width: 'auto',
                  display: 'inline-block',
                }}
              />
            </div>

            <div style={{ textAlign: 'center', marginBottom: 24 }}>
              <Title 
                level={3} 
                style={{ 
                  marginBottom: 8,
                  fontSize: '1.7rem',
                  color: '#1890ff',
                  fontWeight: 600
                  
                }}
              >
                Welcome to the License Plate Recognition (LPR) Lanes Registration System
              </Title>
            </div>
            
            <div style={{ textAlign: 'center', marginBottom: 24 }}>
              <Text style={{ fontSize: '20px', color: '#333', fontWeight: 500 }}>
                Please Select Your Registration Type
              </Text>
            </div>
            
            <Row gutter={[24, 24]} style={{ marginTop: 8 }}>
              <Col xs={24} md={12}>
                <Card
                  hoverable
                  style={{
                    borderRadius: '12px',
                    border: '2px solid #e8e8e8',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                    height: '100%'
                  }}
                  styles={{
                    body: { padding: '24px' }
                  }}
                  onClick={() => navigate(`/resident?id=${parkingLocationId}`)}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#1890ff';
                    e.currentTarget.style.boxShadow = '0 4px 20px rgba(24, 144, 255, 0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = '#e8e8e8';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <div style={{ textAlign: 'center' }}>
                    <div style={{
                      width: '64px',
                      height: '64px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 16px'
                    }}>
                      <UserOutlined style={{ fontSize: '32px', color: 'white' }} />
                    </div>
                    <Title level={4} style={{ marginBottom: 8, marginTop: 0 }}>
                      Resident
                    </Title>
                    <Text style={{ color: '#666', fontSize: '15px' }}>
                      Register your personal vehicle plate number.
                    </Text>
                  </div>
                </Card>
              </Col>
              <Col xs={24} md={12}>
                <Card
                  hoverable
                  style={{
                    borderRadius: '12px',
                    border: '2px solid #e8e8e8',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                    height: '100%'
                  }}
                  styles={{
                    body: { padding: '24px' }
                  }}
                  onClick={() => navigate(`/company?id=${parkingLocationId}`)}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#52c41a';
                    e.currentTarget.style.boxShadow = '0 4px 20px rgba(82, 196, 26, 0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = '#e8e8e8';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <div style={{ textAlign: 'center' }}>
                    <div style={{
                      width: '64px',
                      height: '64px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 16px'
                    }}>
                      <TeamOutlined style={{ fontSize: '32px', color: 'white' }} />
                    </div>
                    <Title level={4} style={{ marginBottom: 8, marginTop: 0 }}>
                      Company
                    </Title>
                    <Text style={{ color: '#666', fontSize: '15px' }}>
                      Register company vehicles and vehicles of employees under your company.
                    </Text>
                  </div>
                </Card>
              </Col>
            </Row>
          </Card>
        </div>
      </Content>
    </Layout>
  );
}